import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import * as ht from './_ht';
import * as hf from './_hm';

/*
20211118 rht を n_pdd に対応させる
20211118 o_drawRglToCvs において backCcd を指定可能とする
 */

const $rto = 2.4;
const $fontSizeNrm = 10;
const $mgnTop = $fontSizeNrm;
const $mgnLeft = 18;
const $rowH = $fontSizeNrm * 1.6;
const $cmnMax = 54; // portrait : 54, landscape : 77
const $rowMax = null; // portrait : null, landscape : 34
const $pdg = $fontSizeNrm * 0.5;

const _addNewPageToPdfAsync = async (
  pdf: ht.o
) => {
  await pdf.addPage();
}

const _clrCvs = (
  cvs: ht.o,
  ctx: ht.o,
) => {
  ctx.clearRect(0, 0, cvs.width, cvs.height);
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, cvs.height, cvs.height);
};

const _cvtCmnToX = (cmn: ht.n) => (cmn ?? 0) * $fontSizeNrm;

const _cvtRowToY = (row: ht.n) => (row ?? 0) * $rowH;

const _drawLineToCvs = (pd: {
  ctx: ht.o,
  x1?: ht.n,
  y1?: ht.n,
  x2?: ht.n,
  y2?: ht.n,
  cmn1?: ht.n,
  row1?: ht.n,
  cmn2?: ht.n,
  row2?: ht.n,
  bc?: ht.s, // border color
  bw?: ht.n, // border width
  dss?: ht.ls, // dash
}) =>{
  //ff.l('333: {}'.f(pd))
  const _x1 = ((pd.cmn1) ? _cvtCmnToX(pd.cmn1) : (pd.x1 ?? 0)) + $mgnLeft;
  const _y1 = ((pd.row1) ? _cvtRowToY(pd.row1) : (pd.y1 ?? 0)) + $mgnTop;
  const _x2 = ((pd.cmn2) ? _cvtCmnToX(pd.cmn2) : (pd.x2 ?? 0)) + $mgnLeft;
  const _y2 = ((pd.row2) ? _cvtRowToY(pd.row2) : (pd.y2 ?? 0)) + $mgnTop;
  pd.ctx.beginPath();
  if (pd.dss) {
    pd.ctx.setLineDash(pd.dss);
  }
  else {
    pd.ctx.setLineDash([]);
  }
//  pd.ctx.moveTo(pd.x1, pd.y1);
//  pd.ctx.lineTo(pd.x2, pd.y2);
  pd.ctx.moveTo(_x1, _y1);
  pd.ctx.lineTo(_x2, _y2);
  pd.ctx.strokeStyle = pd.bc ?? 'black';
  pd.ctx.lineWidth = pd.bw ?? 0.5;
  pd.ctx.stroke();
};

const _drawImgToCvsAsync = (pd: {
  ctx: ht.o,
  url: ht.s,
  x?: ht.n,
  y?: ht.n,
  row?: ht.n,
  cmn?: ht.n,
}) => new Promise( _exit => {
  const _img = new Image();
  _img.src = pd.url;
  _img.crossOrigin = "anonymous"; 
  const _x = ((pd.cmn) ? _cvtCmnToX(pd.cmn) : (pd.x ?? 0)) + $mgnLeft;
  const _y = ((pd.row) ? _cvtRowToY(pd.row) : (pd.y ?? 0)) + $mgnTop;
  const _w = $fontSizeNrm * $cmnMax;
  _img.onload = async () => {
    pd.ctx.drawImage(_img, _x, _y, _w, _w * _img.height / _img.width );
    _exit(true);
  };
});

const _drawQcdToCvsAsync = (pd: {
  ctx: ht.o,
  //url: ht.s,
  x?: ht.n,
  y?: ht.n,
  row?: ht.n,
  cmn?: ht.n,
  pfx: ht.s,
}) => new Promise( _exit => {
  // https://dev.to/scotchbright/jspdf-qr-code-tutorial-code-samples-how-to-generate-a-pdf-with-a-qrcode-using-the-jspdf-qrcode-js-library-2hld
  // https://www.fixes.pub/program/701584.html
  // https://stackoverflow.com/questions/23861986/create-qrcode-with-output-base64-from-javascript/34542431
  // https://blog.katsubemakito.net/nodejs/qrcode-generates
  QRCode.toDataURL(pd.pfx, (_err: ht.a, _base64: ht.a) => {
    const _x = ((pd.cmn) ? _cvtCmnToX(pd.cmn) : (pd.x ?? 0)) + $mgnLeft;
    const _y = ((pd.row) ? _cvtRowToY(pd.row) : (pd.y ?? 0)) + $mgnTop;
    const _w = $fontSizeNrm * 8;
    const _img = new Image();
    _img.src = _base64;
    _img.onload = async () => {
      pd.ctx.drawImage(_img, _x, _y, _w, _w * _img.height / _img.width);
      _exit(true);
    };
  });
})

const _drawRglToCvs = (pd: { // rectangle
  ctx: ht.o,
  x: ht.n,
  y: ht.n,
  w: ht.n,
  h: ht.n,
  bc?: ht.s, // border color
  bw?: ht.n, // border width
  sc?: ht.s, // scene color code
}) => {
  pd.ctx.lineWidth = pd.bw ?? 1;
  if (pd.sc) { // 背景色あり
    pd.ctx.fillStyle = pd.sc;
    pd.ctx.fillRect(pd.x, pd.y, pd.w, pd.h)
    pd.ctx.strokeStyle = pd.bc ?? 'black';
    pd.ctx.strokeRect(pd.x, pd.y, pd.w, pd.h)
  }
  else { // 背景色なし
    pd.ctx.strokeStyle = pd.bc ?? 'black';
    pd.ctx.strokeRect(pd.x, pd.y, pd.w, pd.h)
  }
}

const _drawTextToCvs = (pd: {
  ctx: ht.o,
  pfx: ht.s,
  x?: ht.n,
  y?: ht.n,
  w?: ht.n,
  h?: ht.n,
  cmn?: ht.n,
  row?: ht.n,
  cmnCnt?: ht.n,
  rowCnt?: ht.n,
  ts?: ht.n, // text size
  tc?: ht.s, // text color
  bw?: ht.n, // border width
  bc?: ht.s, // border color
  sc?: ht.s, // scene color
  bold: ht.b,
  frm: ht.b,
  mlt: ht.b,
  ta: ht.s,
}) => {

  const _bw = pd.bw ?? 1;

  const _x1 = (pd.cmn || pd.cmn == 0) ? _cvtCmnToX(pd.cmn) : (pd.x ?? 0);
  const _w = (pd.cmnCnt || pd.cmnCnt == 0) ? _cvtCmnToX(pd.cmnCnt) : (pd.w ?? 0);
  const _x2 = _x1 + _w;
  const _y1 = (pd.row || pd.row == 0) ? _cvtRowToY(pd.row) : (pd.y ?? 0);
  const _h = (pd.rowCnt || pd.rowCnt == 0) ? _cvtRowToY(pd.rowCnt) : (pd.h ?? 0);
  const _y2 = _y1 + _h;

  if (pd.frm) {
    _drawRglToCvs({
      ctx: pd.ctx, 
      x: _x1, 
      y: _y1, 
      w: _w, 
      h: _h, 
      bw: _bw,
      bc: pd.bc,
      sc: pd.sc,
    });
  }

  pd.ctx.font = `${(pd.bold) ? 'bold' : ''} ${(pd.ts ?? 1 ) * $fontSizeNrm}pt -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`;

  if (hf.f(pd.pfx)) {
    pd.ctx.fillStyle = pd.tc ?? 'black';
    const _l = [];
    let _s = '';
//    const _w = _cvtCmnToX(pd.cmnCnt ?? 0);
    const _cmnW = _cvtCmnToX(pd.cmnCnt ?? $cmnMax); // 超過時の折り返しを考慮
    for ( let _i = 0; _i < pd.pfx.length; _i++) {
      const _msrz = _msrText(pd.ctx, _s + pd.pfx.charAt(_i))
      //hf.l(`cmPDF 176: ${_msrz.w + 10}, ${pd.cmnCnt}, ${_cvtCmnToX(pd.cmnCnt ?? 0)}, ${_s}, ${hf.s(_l)}`);
      if ( (_msrz.w + 10) >= _cmnW ) {
      //if ( _w > 0 && (_msrz.w + 10) >= _w ) { // cmnCnt 未指定の場合、_w > 0 でスルー
        _l.push(_s);
        _s = '';
      }
      _s += pd.pfx.charAt(_i);
    }
    if ( hf.f(_s) ) _l.push(_s);
    //hf.l(`cmPDF 186: ${_cmnW}, ${hf.s(_l)}`);
    const _cnt = _l.length;

    const _mlt = _cnt <= 1 ? false : (pd.mlt ?? false); // 改行されない場合は、元データに改行があるか確認
    const _rowCnt = _msrText(pd.ctx, 'あ').h;
    const _adjY = 
      (_mlt) ? 
        ( _h - _cvtRowToY(_cnt) ) / 2
      :
        ( _h - _rowCnt * _cnt ) / 2;

    _l.map( (_pfx, _idx) => {

      const _msrs = _msrText(pd.ctx, _pfx) // font size に影響があるものは msrText 前に実行
      const _adjX = 
        (pd.ta == 'l') ? 
          $pdg
        : (pd.ta == 'c') ? 
          ( _w - _msrs.w ) / 2
        : (pd.ta == 'r') ? 
          ( _w - _msrs.w - $pdg)
        : 0;
      
      const _y = 
        (_mlt) ? 
          ( _y1 + _cvtRowToY(_idx + 1) + _adjY ) 
        : ( _y1 + _rowCnt + _adjY );
      //ff.l('myPD 160: {}, {}, {}, {}, {}, {}'.f(_idx, _pfx, pd.b_mln, _n_cnt, _b_mln, _n_y));

      pd.ctx.fillText(
        _pfx ?? '', 
        (pd.mlt) ? (_x1 + 5) : (_x1 + _adjX),
        _y
      );
    } );
  }
};

const _msrText = (
  ctx: ht.o, 
  text: ht.s
) => { 
/*
measureText will use the currently set font property, and is also relative to the current context's transform
https://stackoverflow.com/questions/60954558/canvas-context-measuretext-not-working-properly
*/
  const _msrs = ctx.measureText(text);
  return { 
    w: _msrs.width,
    h: $fontSizeNrm,
  };
};

const _pstCvsToPdfAsync = async ( // paste canvas to pdf
  cvs: ht.o,
  pdf: ht.o,
) => {
  const _img = await cvs.toDataURL('image/png', 1.0)
  await pdf.addImage(_img, 'PNG', $mgnLeft, $mgnTop, cvs.width / $rto, cvs.height / $rto, undefined, 'FAST')
};

const _savePdfAsync = async (
  pdf: ht.o,
  fileName: ht.s,
) => {
  await pdf.save(fileName)
};

export const dldFileAsync = (pd: {
  lines: {
    ctx?: ht.o,
    pdf?: ht.o,
    type: ht.s,
    x?: ht.n,
    y?: ht.n,
    w?: ht.n,
    h?: ht.n,
    x1?: ht.n,
    y1?: ht.n,
    x2?: ht.n,
    y2?: ht.n,
    pfx?: ht.s,
    cmn?: ht.n,
    row?: ht.s,
    cmnCnt?: ht.n,
    rowCnt?: ht.n,
    bc?: ht.s, // border color
    bw?: ht.s, // border width
    sc?: ht.s, // scene color
    ta?: ht.s, // text align
    frm?: ht.b, // with frame
    mlt?: ht.b, // with multi line
    bold?: ht.b, // with bold
  }[],
  fileName?: ht.s,
  ttl?: ht.s,
  itlz?: ht.dz,
}) => new Promise( _exit => { // only for web

  const _itlz = {
    orientation: 'landscape', // portrait
    unit: 'pt',
    format: 'a4',
    compress: true,
    ...pd.itlz
  };
  const _pdf = new jsPDF(_itlz);

  const _cvs = document.createElement('canvas');
  _cvs.width = 297 * 4 * $rto;
  _cvs.height = _cvs.width / 297.0 * 210.0; // a4 l 400dpi

  const _ctx = _cvs.getContext('2d');
  _ctx?.scale($rto, $rto);

  _clrCvs(_cvs, _ctx);

  let _url = '';

  const _ls = pd.lines.map((_linez: ht.a) => {
    switch (_linez.type) {
      case 'addNewPageToPdf':
        return async () => {
          await _addNewPageToPdfAsync(_pdf);
          return true;
        }
      case 'clrCvs':
        return async () => {
          _clrCvs(_cvs, _ctx);
          return true;
        }
      case 'grtUrl':
        return async () => {
          _pdf.setProperties({
            title: pd.fileName,
          })
          _url = URL.createObjectURL(_pdf.output("blob"));
          return _url;
        }
      case 'img':
        return async () => {
          await _drawImgToCvsAsync({
            ctx: _ctx,
            x: 0,
            ..._linez
          });
          return true;
        }
      case 'line':
        return async () => {
          _drawLineToCvs({
            ctx: _ctx,
            ... _linez
          });
          return true;
        }
      case 'pstCvsToPdf':
        return async () => {
          await _pstCvsToPdfAsync(_cvs, _pdf);
          return true;
        }
      case 'qcd':
        return async () => {
          await _drawQcdToCvsAsync({
            ctx: _ctx,
            x: 0,
            ... _linez
          });
          return true;
        }
      case 'savePdf':
        return async () => {
          await _savePdfAsync(_pdf, pd.fileName ?? '');
          return true;
        }
      case 'text':
        return async () => {
          _drawTextToCvs({
            ctx: _ctx,
            rowCnt: 1,
            ... _linez
          });
          return true;
        }
      default:
        return async () => {
          hf.l(`cmPDF 357: incorrect type: ${_linez.type}`);
          return false;
        }
    }
  });

  hf.ectSrlAsync(_ls)
  .then((_b: ht.b) => {
    //hf.l(`cmPDF 370: ${hf.s(_url)}`);
    if (hf.f(_url)) {
      _exit(_url);
    }
    else {
      _exit(_b);
    }
  })
});

/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
